<script>
  export let items
</script>

<ul>
  {#each items as item}
    <li>
      <a href={item.url} target='_blank' rel='noopener noreferrer'>
        {item.name}
      </a>
    </li>
  {/each}
</ul>


<style>
  a {
    border-bottom: 3px solid transparent;
    transition: border-color 0.2s;
    &:hover {
      border-color: var(--red);
    }
  }
</style>
